function getYoutubeId(url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  if (url !== undefined) {
    const match = url.match(regExp);
    return match && match[7].length === 11 ? match[7] : false;
  }
  return false;
}

export { getYoutubeId };
